import { useCallback, useMemo } from 'react'
import { buildChatExchanges } from './buildChatExchanges.js'

/** @typedef {import('./chatThreadTypes.js').ChatMessage} ChatMessage */

/**
 * @param {ChatMessage[]} messages
 * @param {Record<string, number>} activeQueryVersionByExchangeId
 */
export function useChatThreadExchanges(messages, activeQueryVersionByExchangeId) {
  const exchanges = useMemo(() => buildChatExchanges(messages), [messages])

  const getExchangeDisplayUser = useCallback(
    (ex) => {
      const { exchangeId, queryVersions } = ex
      const queryVersionIndices = [...queryVersions.keys()]
        .filter((idx) => Boolean(queryVersions.get(idx)?.user))
        .sort((a, b) => a - b)
      if (queryVersionIndices.length === 0) return null

      const maxQueryVersionIndex = queryVersionIndices[queryVersionIndices.length - 1]
      const activeQueryVersionIndex =
        typeof activeQueryVersionByExchangeId[exchangeId] === 'number'
          ? activeQueryVersionByExchangeId[exchangeId]
          : maxQueryVersionIndex

      const activeQuery =
        queryVersions.get(activeQueryVersionIndex) ?? queryVersions.get(maxQueryVersionIndex)
      return activeQuery?.user ?? null
    },
    [activeQueryVersionByExchangeId],
  )

  return { exchanges, getExchangeDisplayUser }
}
